// A small CSV reader for previews (quoted fields, "" escapes, line breaks inside quotes). Stops at
// `max` rows so a huge file previews instantly.
export const parseCsv = (text: string, max = 200, sep = ","): string[][] => {
  const rows: string[][] = [];
  let row: string[] = [], cell = "", quoted = false;
  for (let i = 0; i < text.length && rows.length < max; i++) {
    const c = text[i];
    if (quoted) {
      if (c === '"' && text[i + 1] === '"') { cell += '"'; i++; }
      else if (c === '"') quoted = false;
      else cell += c;
    } else if (c === '"' && cell === "") quoted = true;
    else if (c === sep) { row.push(cell); cell = ""; }
    else if (c === "\n" || c === "\r") {
      if (c === "\r" && text[i + 1] === "\n") i++;
      row.push(cell); rows.push(row); row = []; cell = "";
    } else cell += c;
  }
  if ((cell || row.length) && rows.length < max) { row.push(cell); rows.push(row); }
  return rows;
};
